import { styled } from 'styled-components';

import {
  bodySmallText,
  colors,
  cssBreakpoints,
  spacing,
  transition,
} from 'theme/theme';

const smallFilePickerBrandBlueWhenMouseActiveVar =
  '--small-file-picker-brand-blue-when-mouse-active';
const smallFilePickerWhiteWhenMouseActiveVar =
  '--small-file-picker-white-when-mouse-active';

export const SmallFilePickerWrapper = styled.div`
  position: relative;
`;

export const SmallFilePickerContent = styled.div`
  display: flex;
  gap: 24px;
  transition: background ${transition};
  border-radius: 4px;
  padding: ${spacing[8]} ${spacing[12]};

  &[data-loading] {
    align-items: center;
    justify-content: center;
    height: 60px;
  }

  &[data-loading],
  &[data-mouse-active] {
    background: ${colors.softBlue};

    ${smallFilePickerBrandBlueWhenMouseActiveVar}: ${colors.brandBlue};
    ${smallFilePickerWhiteWhenMouseActiveVar}: ${colors.white};
  }

  @media all and (width >= ${cssBreakpoints.mdUp}) {
    align-items: center;
  }

  @media all and (width < ${cssBreakpoints.mdDown}) {
    flex-direction: column;
  }
`;

export const SmallFilePickerChooseOrDragItHere = styled.div`
  ${bodySmallText};
  display: flex;
  gap: 8px;
  align-items: center;
  text-wrap: nowrap;

  transition:
    border ${transition},
    background ${transition},
    color ${transition};
  padding: ${spacing[6]} ${spacing[16]};
  border-radius: 8px;
  border: 1px solid
    var(${smallFilePickerBrandBlueWhenMouseActiveVar}, ${colors.brandBlue});
  color: var(${smallFilePickerWhiteWhenMouseActiveVar}, ${colors.brandBlue});
  background: var(${smallFilePickerBrandBlueWhenMouseActiveVar}, transparent);
`;

export const SmallFilePickerNoFileChosenHelpText = styled.div`
  color: ${colors.lightContentGrey};
`;
